import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AppFooter = ({ variant = "default" }) => {
  const { t } = useTranslation();
  const isCompact = variant === "compact";
  return (
    <footer className={`border-t border-gray-100 bg-white/80 ${isCompact ? "py-3 px-4" : "py-4 px-4 sm:py-6"}`}>
      <div className={`max-w-4xl mx-auto ${isCompact ? "" : "space-y-2"}`}>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-gray-600">
          <Link to="/legal" className="hover:text-brand font-medium transition-colors">
            {t("footer.legal")}
          </Link>
          <span className="hidden sm:inline text-gray-300">•</span>
          <Link to="/privacy" className="hover:text-brand font-medium transition-colors">
            {t("footer.privacy")}
          </Link>
          <span className="hidden sm:inline text-gray-300">•</span>
          <Link to="/cookies" className="hover:text-brand font-medium transition-colors">
            {t("footer.cookies")}
          </Link>
          <span className="hidden sm:inline text-gray-300">•</span>
          <Link to="/terms" className="hover:text-brand font-medium transition-colors">
            {t("footer.terms")}
          </Link>
          <span className="hidden sm:inline text-gray-300">•</span>
          <Link to="/terms-of-sale" className="hover:text-brand font-medium transition-colors">
            {t("footer.termsOfSale")}
          </Link>
          <span className="hidden sm:inline text-gray-300">•</span>
          <Link to="/support" className="hover:text-brand font-medium transition-colors">
            {t("footer.support")}
          </Link>
        </div>
        {!isCompact && (
          <p className="text-center text-xs text-gray-500">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
        )}
      </div>
    </footer>
  );
};

export default AppFooter;
